import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import React, { useEffect } from "react";

import { saveCredential } from "src/features/Oauth/oauth.ducks";

// *********************************
// prase with URLSearchParams √ e.g. search ?=a=1&b=2 -> { a:1, b:2 }
// *********************************
function parseURLSearchParams(search) {
  return [...new URLSearchParams(search).entries()].reduce(
    (q, [k, v]) => Object.assign(q, { [k]: v }),
    {}
  );
}

const CallbackOauth = () => {
  // *********************************
  // redux state
  // *********************************
  const dispatch = useDispatch();
  const searchParams = useSelector((state) => state.router.location.search);
  // *********************************
  // prase with URLSearchParams √ e.g. search ?=a=1&b=2 -> { a:1, b:2 }
  // *********************************
  const query = parseURLSearchParams(searchParams);
  // *********************************
  // Save credential then redirect by epic 🙂
  // *********************************
  useEffect(() => {
    const access_token = get(query, "access_token", "");
    const refresh_token = get(query, "refresh_token", "");
    const ref_code = get(query, "ref_code", "");
    dispatch(saveCredential(access_token, refresh_token, ref_code, "/"));
  }, [dispatch, query]);

  return (
    <div>
      <pre>เรากำลังพาคุณไปหน้าต่อไป</pre>
    </div>
  );
};

export default CallbackOauth;
